import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Link as RouterLink } from 'react-router-dom';

const Link = ({
  className = '',
  href,
  to,
  children,
  isExternal = false,
  theme = 'primary',
  withArrow = false,
  tagName,
  handleClick,
  ...props
}) => {
  const baseClasses = 'inline-flex items-center text-green-400 hover:text-green-300 transition-colors duration-200';
  const themeClasses = {
    primary: 'text-green-400 hover:text-green-300',
    white: 'text-white hover:text-gray-200',
    underline: 'text-green-400 hover:text-green-300 underline underline-offset-4',
  };

  const classes = clsx(
    baseClasses,
    themeClasses[theme],
    withArrow && 'group inline-flex items-center gap-1',
    className
  );

  // If it's a react-router link
  if (to) {
    return (
      <RouterLink
        to={to}
        className={classes}
        onClick={handleClick}
        {...props}
      >
        {children}
        {withArrow && (
          <span className="ml-1 transition-transform duration-200 group-hover:translate-x-1">
            →
          </span>
        )}
      </RouterLink>
    );
  }

  // Regular anchor link
  return (
    <a
      href={href}
      className={classes}
      target={isExternal ? '_blank' : undefined}
      rel={isExternal ? 'noopener noreferrer' : undefined}
      {...props}
    >
      {children}
      {withArrow && (
        <span className="ml-1 transition-transform duration-200 group-hover:translate-x-1">
          →
        </span>
      )}
    </a>
  );
};

Link.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  to: PropTypes.string,
  children: PropTypes.node.isRequired,
  isExternal: PropTypes.bool,
  theme: PropTypes.oneOf(['primary', 'white', 'underline']),
  withArrow: PropTypes.bool,
  tagName: PropTypes.string,
  handleClick: PropTypes.func,
};

export default Link;